export const INTL_LANG = '@intl/INTL_LANG';
export type INTL = typeof INTL_LANG;

export interface SetIntl {
  type: INTL;
  payload: {
    intl: any,
  }
}

export function setIntl(intl: any): SetIntl {
  return {
    type: INTL_LANG,
    payload: {
      intl: intl
    }
  };
}